/* eslint-disable react/display-name */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-vars */
import React, { ReactNode, useEffect, useRef, useState } from 'react';
import {
  IClientReportColumns,
  IFilterDropdownProps,
  ILead,
  IOfficeBranch,
  IUser,
} from '@shared-components/models';
import { FilterConfirmProps } from 'antd/lib/table/interface';
import { ColumnType } from 'antd/lib/table';
import { Checkbox, DatePicker, Form, Input, Row, Tag, Typography } from 'antd';
import { Button, formatDateWithTimezone } from '@moxie/shared';
import { LABEL, SEARCH, TEXT, URL_DETAIL_LINK } from '@moxie/constants';
import { FilterFilled, SearchOutlined } from '@ant-design/icons';
import moment, { Moment } from 'moment';
import { Link } from 'react-router-dom';
import { RangeValue } from 'rc-picker/lib/interface';
import { getContactsReportFilterData } from '@lyra/services.api';
import { useAppSelector } from '@lyra/core';

const { Text } = Typography;
const { RangePicker } = DatePicker;
const CheckboxGroup = Checkbox.Group;

const ContactReportTableColumns = (
  setFilter: (key: string, value: string) => void
) => {
  const userTimeZone =
    useAppSelector((store) => store?.auth?.user?.time_zone) || '';
  const [countryList, setCountryList] = useState();
  const [branchList, setBranchList] = useState();
  const [assigneeList, setAssigneeList] = useState();
  const [userList, setUserList] = useState();
  const [statusList, setStatusList] = useState();

  useEffect(() => {
    (async () => {
      const response = await getContactsReportFilterData();
      setCountryList(response?.data?.country);
      setBranchList(response?.data?.branches);
      setAssigneeList(response?.data?.assignee);
      setUserList(response?.data?.addedBy);
      setStatusList(response?.data?.status);
    })();
  }, []);

  type DataIndex = keyof IClientReportColumns;
  const searchInput = useRef(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: (param?: FilterConfirmProps) => void,
    dataIndex: DataIndex,
    multipleData?: boolean
  ) => {
    confirm();
    setTimeout(() => {
      if (multipleData) {
        setFilter(dataIndex, selectedKeys.join());
        return;
      }
      setFilter(dataIndex, selectedKeys[0]);
    }, 500);
  };

  const handleReset = (clearFilters: () => void, dataIndex: string) => {
    clearFilters();
    setTimeout(() => {
      setFilter(dataIndex, '');
    }, 500);
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex,
    name?: string
  ): ColumnType<IClientReportColumns> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }: any) => {
      return (
        <div className="table-column-search-dropdown">
          <Input
            className="table-column-search-input"
            ref={searchInput}
            placeholder={`Search ${name}`}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
          />
          <Row justify="space-between">
            <Button
              className="margin-left-2"
              onClick={() =>
                clearFilters && handleReset(clearFilters, dataIndex)
              }
              size="small"
            >
              {LABEL.RESET}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                handleSearch(selectedKeys as string[], confirm, dataIndex);
              }}
              size="small"
            >
              {SEARCH}
            </Button>
          </Row>
        </div>
      );
    },
    filterIcon: (filtered: boolean) => {
      return (
        <SearchOutlined className={filtered ? 'table-column-search-btn' : ''} />
      );
    },
  });

  const getStatusFilterProps = (
    dataIndex: DataIndex
  ): ColumnType<IClientReportColumns> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }: IFilterDropdownProps) => {
      const handleStatusChange = (list: any) => {
        setSelectedKeys(list);
      };

      return (
        <div>
          <Form className="border-bottom padding-1">
            <Form.Item className="margin-bottom-0">
              <CheckboxGroup
                className="custom_role_vertical--checkbox"
                options={
                  dataIndex === 'status'
                    ? statusList
                    : dataIndex === 'country'
                    ? countryList
                    : dataIndex === 'branch'
                    ? branchList
                    : dataIndex === 'assignee'
                    ? assigneeList
                    : userList
                }
                onChange={handleStatusChange}
                value={selectedKeys}
              />
            </Form.Item>
          </Form>

          <Row className="padding-1" justify="space-between">
            <Button
              onClick={() => {
                clearFilters && handleReset(clearFilters, dataIndex);
                setSelectedKeys([]);
              }}
              size="small"
            >
              {LABEL.RESET}
            </Button>
            <Button
              type="primary"
              onClick={() => {
                handleSearch(
                  selectedKeys as string[],
                  confirm,
                  dataIndex,
                  true
                );
              }}
              size="small"
            >
              {TEXT.STATUS_DONE}
            </Button>
          </Row>
        </div>
      );
    },
    filterIcon: (filtered: boolean) => {
      return (
        <FilterFilled className={filtered ? 'table-column-search-btn' : ''} />
      );
    },
  });

  const getDateFilterProps = (
    dataIndex: DataIndex
  ): ColumnType<IClientReportColumns> => {
    return {
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
      }: IFilterDropdownProps) => {
        const handleRangeChange = (
          data: RangeValue<Moment>,
          values: string[]
        ) => {
          let dateRange: React.Key[] = [];
          if (data) {
            dateRange = [
              values[0] && moment(values[0]).format('YYYY-MM-DD'),
              values[1] && moment(values[1]).format('YYYY-MM-DD'),
            ];
          }

          setSelectedKeys(dateRange);
        };
        return (
          <div className="padding-1">
            <Form>
              <Form.Item>
                <RangePicker
                  format="MMM DD, YYYY"
                  onChange={handleRangeChange}
                />
              </Form.Item>
              <Row justify="end" className="margin-top-n2">
                <Button
                  type="primary"
                  onClick={() =>
                    handleSearch(
                      selectedKeys as string[],
                      confirm,
                      dataIndex,
                      true
                    )
                  }
                  size="small"
                >
                  {TEXT.STATUS_DONE}
                </Button>
              </Row>
            </Form>
          </div>
        );
      },
      filterIcon: (filtered: boolean) => {
        return (
          <FilterFilled className={filtered ? 'table-column-search-btn' : ''} />
        );
      },
    };
  };

  return [
    {
      title: LABEL.CLIENT_INTERNAL_ID,
      width: 200,
      dataIndex: 'internal_id',
      sorter: () => 0,
      ...getColumnSearchProps('internal_id', 'Internal Id'),
      render: (value: string, data: ILead): ReactNode => {
        return (
          <div className="lead-table__city">
            <Link to={`${URL_DETAIL_LINK}${data?.id}/profile-section`}>
              <Text className="text-primary-color">
                {data?.company?.company_code + '-' + value}
              </Text>
            </Link>
          </div>
        );
      },
    },

    {
      title: LABEL.CONTACT,
      width: 300,
      dataIndex: 'client_name',
      ellipsis: true,
      sorter: () => 0,
      ...getColumnSearchProps('client_name', 'Client Name'),
      render: (
        value: string,
        { id, first_name, last_name }: ILead
      ): ReactNode => {
        return (
          <div className="lead-table__phone">
            <Link to={`${URL_DETAIL_LINK}${id}/profile-section`}>
              <Text className="text-primary-color initial_capital">{`${first_name} ${last_name}`}</Text>
            </Link>
          </div>
        );
      },
    },

    {
      title: LABEL.STATUS,
      width: 200,
      dataIndex: 'status',
      ...getStatusFilterProps('status'),
      sorter: () => 0,
      render: (value: string): ReactNode => {
        return (
          <div className="lead-table__added-from">
            <Tag className="tag-color">{value}</Tag>
          </div>
        );
      },
    },

    {
      title: TEXT.PHONE,
      width: 200,
      ellipsis: true,
      ...getColumnSearchProps('phone', 'Phone'),
      render: ({ country_code, phone }: ILead): ReactNode => {
        return (
          <div className="lead-table__phone">{`${country_code} ${phone}`}</div>
        );
      },
    },

    {
      title: LABEL.EMAIL,
      width: 200,
      dataIndex: 'email',
      ellipsis: true,
      ...getColumnSearchProps('email', 'Email'),
      sorter: () => 0,
      render: (email: string): ReactNode => {
        return (
          <div className="lead-table__email">
            <a
              className="text-primary-color initial_small"
              href={`mailto:${email}`}
            >
              {email}
            </a>
          </div>
        );
      },
    },

    {
      title: LABEL.DATE_OF_BIRTH,
      width: 300,
      dataIndex: 'date_of_birth',
      sorter: () => 0,
      render: (value: string): ReactNode => {
        return (
          <div className="lead-table__visa-expiry-date">
            {value ? moment(value).format('MMM DD, YYYY') : '-'}
          </div>
        );
      },
    },

    {
      title: TEXT.ADDED_BY,
      width: 300,
      dataIndex: 'user',
      ellipsis: true,
      sorter: () => 0,
      // ...getStatusFilterProps('added_by'),
      render: (data: IUser): ReactNode => {
        return data ? (
          <div className="lead-table__phone">
            {`${data?.first_name} ${data?.last_name}`}
          </div>
        ) : (
          '-'
        );
      },
    },

    {
      title: LABEL.ADDED_DATE,
      width: 200,
      dataIndex: 'created_at',
      // ...getDateFilterProps('created_at'),
      sorter: () => 0,
      render: (value: string): ReactNode => {
        return (
          <div className="lead-table__visa-expiry-date">
            {value && formatDateWithTimezone(value, userTimeZone)}
          </div>
        );
      },
    },

    {
      title: LABEL.ASSIGNEE,
      width: 200,
      dataIndex: 'assignee',
      ellipsis: true,
      // ...getStatusFilterProps('assignee'),
      sorter: () => 0,
      render: (data: IUser): ReactNode => {
        return data ? (
          <div className="lead-table__phone">
            {`${data?.first_name} ${data?.last_name}`}
          </div>
        ) : (
          '-'
        );
      },
    },

    {
      title: LABEL.BRANCH,
      width: 200,
      dataIndex: 'branch',
      ellipsis: true,
      // ...getStatusFilterProps('branch'),
      sorter: () => 0,
      render: (data: IOfficeBranch): ReactNode => {
        return (
          <div className="lead-table__city">{data ? data?.name : '-'}</div>
        );
      },
    },

    {
      title: LABEL.STREET,
      width: 200,
      dataIndex: 'street',
      ellipsis: true,
      sorter: () => 0,
      render: (value: string): ReactNode => {
        return (
          <div className="lead-table__city initial_capital">
            {value ? value : '-'}
          </div>
        );
      },
    },

    {
      title: LABEL.CITY,
      width: 200,
      dataIndex: 'city',
      ellipsis: true,
      sorter: () => 0,
      render: (value: string): ReactNode => {
        return (
          <div className="lead-table__city initial_capital">
            {value ? value : '-'}
          </div>
        );
      },
    },

    {
      title: LABEL.STATE,
      width: 200,
      dataIndex: 'state',
      ellipsis: true,
      sorter: () => 0,
      render: (value: string): ReactNode => {
        return (
          <div className="lead-table__city initial_capital">
            {value ? value : '-'}
          </div>
        );
      },
    },

    {
      title: LABEL.COUNTRY_OF_RESIDENCE,
      width: 200,
      dataIndex: 'country',
      // ...getStatusFilterProps('country'),
      ellipsis: true,
      sorter: () => 0,
      render: (value: string): ReactNode => {
        return <div className="lead-table__city">{value ? value : '-'}</div>;
      },
    },

    {
      title: LABEL.COUNTRY_OF_PASSPORT,
      width: 200,
      dataIndex: 'country_of_passport',
      ellipsis: true,
      sorter: () => 0,
      render: (value: string): ReactNode => {
        return <div className="lead-table__city">{value ? value : '-'}</div>;
      },
    },

    {
      title: LABEL.PASSPORT_NUMBER,
      width: 200,
      dataIndex: 'passport_no',
      ellipsis: true,
      sorter: () => 0,
      render: (value: string): ReactNode => {
        return (
          <div className="lead-table__city">
            {value ? value.toUpperCase() : '-'}
          </div>
        );
      },
    },

    {
      title: LABEL.PASSPORT_EXPIRY_DATE,
      width: 200,
      dataIndex: 'passport_expiry_date',
      // ...getDateFilterProps('passport_expiry_date'),
      ellipsis: true,
      sorter: () => 0,
      render: (value: string): ReactNode => {
        return (
          <div className="lead-table__visa-expiry-date">
            {value ? moment(value).format('MMM DD, YYYY') : '-'}
          </div>
        );
      },
    },

    {
      title: LABEL.VISA_EXPIRY_DATE,
      width: 200,
      dataIndex: 'visa_expiry_date',
      // ...getDateFilterProps('visa_expiry_date'),
      ellipsis: true,
      sorter: () => 0,
      render: (value: string): ReactNode => {
        return (
          <div className="lead-table__visa-expiry-date">
            {value ? moment(value).format('MMM DD, YYYY') : '-'}
          </div>
        );
      },
    },
  ];
};

export { ContactReportTableColumns };
